import { render, staticRenderFns } from "./NewServer.vue?vue&type=template&id=3c38c9bc&scoped=true"
import script from "./NewServer.vue?vue&type=script&lang=js"
export * from "./NewServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38c9bc",
  null
  
)

export default component.exports